import React, { useEffect } from "react";
import {
  Container,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import { CustomBootstrapTable } from 'components/Table/CustomBootstrapTable';
import {  DealsColumnList } from "helpers/tableDataMapper";
import { useSelector, useDispatch } from "react-redux";
import { getDeals, getWordiconPacks } from "store/actions";
import { MdEdit, MdOutlineRemoveRedEye } from "react-icons/md";

const DealsList = (props) => {
    const dispatch = useDispatch();

    const { dealsList } = useSelector(state => ({
        dealsList: state.deals.dealsList,
    }));
    
    useEffect(() => {
        let queryPayload = {
            search: '',
        }
        dispatch(getDeals(queryPayload));
    }, [dispatch, props]);

    const getApplicationDetails = (row) => {
        props.history.push(`/staff/deal/detail/${row[7]}`)
    }
    const filterList = (queryPayload) => {
        let payload = {
            ...queryPayload
        }
        dispatch(getDeals(payload))
    }

    const getTableColumns = () => {
        let editObj = {
            label: "Actions",
            name: '',
            options: { 
                filter: true,
                sort: false, 
                customBodyRender: (value, tableMeta, updateValue) => (
                    <div className='d-flex align-items-center justify-content-center'>
                        <div
                            className="ms-1"
                            onClick={() => getApplicationDetails(tableMeta?.rowData)}
                        >
                            <MdEdit size={16}/>
                        </div>  
                    </div>
                )
            }
        }
        let newtable = [...DealsColumnList,editObj]
         return newtable
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Deals" breadcrumbItem="Deals List" />
                    <CustomBootstrapTable 
                        rows = {dealsList}
                        columns = {getTableColumns()}
                        isLoading={false}
                        showCreateBtn = {true}
                        keyField={'_id'}
                        createBtnLabel="Create Deal"
                        onCreateRedirect = {`/staff/deal/detail`}
                        getApplicationDetails={(row) => null}
                        showStatusFilter={false}
                        showDateFilter={false}
                        history = {props.history}
                        filterList = {(...params) => filterList(...params)}
                    />
                </Container>
            </div>
        </React.Fragment>
    )
}

export { DealsList }